<template>
  <table class="table">
    <thead>
      <tr>
        <th width="80%">
          <div>
            {{ hiddenFields }}
            {{ hiddenFields === 1 ? hiddenFieldLabel : hiddenFieldsLabel }}
          </div>
        </th>
        <th v-for="property in fieldsVisibilityProperties">
          <p>{{ property.name }}</p>
          <div class="checkbox">
            <label :for="`select-all-${property.id}`">
              <input
                type="checkbox"
                :id="`select-all-${property.id}`"
                :checked="allSelected(property.id)"
                @change.prevent="event => $emit('selectAll', property.id, event.target.checked)"
              /> {{ selectAllLabel }}
            </label>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="field in fieldsVisibility">
        <td>{{ field.title }}</td>
        <td v-for="property in fieldsVisibilityProperties">
          <input
            :aria-label="field.title + ' - ' + property.name"
            type="checkbox"
            :name="`fields[${field.id}][${property.id}]`"
            :checked="field[property.id]"
            @change.prevent="event => $emit('select', field.id, property.id, event.target.checked)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    fieldsVisibility: {
      type: Array,
      required: true
    },
    fieldsVisibilityProperties: {
      type: Array,
      required: true
    },
    selectAllLabel: {
      type: String,
      default: 'Select all'
    },
    hiddenFields: {
      type: Number,
      default: 0
    },
    hiddenFieldLabel: {
      type: String,
      default: 'hidden field'
    },
    hiddenFieldsLabel: {
      type: String,
      default: 'hidden fields'
    }
  },
  computed: {
    allSelected() {
      return property => {
        const all = this.fieldsVisibility.length;
        const selected = this.fieldsVisibility.filter(field => field[property] === true).length;

        return all === selected;
      }
    }
  }
};
</script>
